import { Container } from "./Container";
import { IconButton } from "./IconButton";
import { siteConfig } from "../data/portfolio";

/** Hairline footer: one credit line and a row of circular social links. */
export function SiteFooter() {
  return (
    <footer className="border-hairline border-t py-8">
      <Container className="flex flex-wrap items-center justify-between gap-5">
        <p className="text-muted text-sm">
          {`© ${new Date().getFullYear()} ${siteConfig.name}. Built with React, Tailwind CSS, and Cloudflare.`}
        </p>
        <div className="flex items-center gap-2">
          {siteConfig.socialLinks.map((link) => (
            <IconButton
              key={link.label}
              icon={link.icon}
              label={link.label}
              href={link.href}
              variant="plain"
            />
          ))}
        </div>
      </Container>
    </footer>
  );
}
